import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import apiPreshift from '../../../api/apiPreshift';
import {pageLoadManageActions as loader} from "../../../reducers/load";
import Breams from '../../blocks/Breams';
import Loader from '../../blocks/Loader';
import Course from '../../screens/electronicCourses/Course';
import EndCourse from '../../screens/electronicCourses/EndCourse';
import EndLesson from '../../screens/electronicCourses/EndLesson';
import EndTheme from '../../screens/electronicCourses/EndTheme';
import QuestionStepper from '../../steppers/QuestionStepper';
import DemoCourseSet from '../../screens/electronicCourses/DemoCourseSet';
import apiDemoCourseSets from "../../../api/apiDemoCourseSet";
import { notify } from '../../blocks/Notify';
import { addBreamb, resetBreamb } from '../../../reducers/breams-manage';
import preshiftManage from '../../../reducers/preshift-manager';

class DemoCourseViewContainer extends Component {

    constructor(props){
        super(props)
        this.state = {
            content: DemoCourseSet,
            activeCourse: null,
            activeLessonIndex:0,
            activeLessons: null,
            activeLesson:null,
            activeTopic: null,    
            activeTopicIndex: 0,            
            course_title: null,
            courseSet:[],
            is_exit_timer: true            
        }
        this.getDemoSet();        
    }
    handleExitTimer = () => this.setState({is_exit_timer: false});
    getDemoSet = async () => {
        return new Promise((resolve,reject)=>{
            loader.start("demo-course-view");        
            apiDemoCourseSets.getDemoCourSet()
            .then((result) => {                
                const courses = result?.data?.courses || [];
                const validatedCourses = courses.length > 0 
                    ? courses.map(course => ({
                        title: course.title || "Без названия",
                        uuid: course.uuid || ""
                    }))
                    :[];
                
                this.setState({courseSet:validatedCourses});
                 resolve();                
            })
            .catch((error) => {
                console.error("Ошибка при получении данных:", error);
               
            }).finally(() => loader.stop("demo-course-view"))   ;
        });
    }

    

    handleChangeContent = (new_content, uuid, course_title = null) => {
        switch (new_content) {            
            case "DemoCourseSet":
                this.setState({
                    content:DemoCourseSet,
                    activeCourse: null,
                    activeLessonIndex:0,
                    activeLessons: null,
                    activeLesson:null,
                    activeTopic: null,    
                    activeTopicIndex: 0,            
                    course_title: null
                });

                break;
            case "Course":
              this.getCourse(uuid)
              .then(() => {
                resetBreamb();
                addBreamb({title: this.props.t('Electronic courses')});
                addBreamb({title: course_title ? course_title : this.state.course_title});
                this.setState({content: Course});
              })
              break;
            case "EndTheme":
              resetBreamb();
              addBreamb({title: this.props.t('Electronic courses')});
              addBreamb({title: this.state.course_title});
              addBreamb({title: this.props.t('End of theme')});
              this.setState({content: EndTheme});
              break;
            case "EndLesson":
              resetBreamb();
              addBreamb({title: this.props.t('Electronic courses')});
              addBreamb({title: this.state.course_title});
              addBreamb({title: this.props.t('End of lesson')});
              this.setState({content: EndLesson});
              break;
            case "EndCourse":
              resetBreamb();
              addBreamb({title: this.props.t('Electronic courses')});
              addBreamb({title: this.state.course_title});
              addBreamb({title: this.props.t('End of course')});
              this.setState({content: EndCourse});
              break;
            case "QuestionStepper":
              preshiftManage.setCameFrom('electronic-courses');
              this.setState({content: QuestionStepper});
              break;
            default:
                return this.state.content;
        }
    };

    getCourse = (uuid) => {
        return new Promise((resolve, reject) => {
            loader.start("demo-course-view");                 
            apiPreshift.getElectronicCourse(uuid)
            .then(res => {
                const course = res.data;
                const lesson = course.lessons[this.state.activeLessonIndex];
                const topic = lesson.topics[this.state.activeTopicIndex];
                this.setState({
                    activeCourse: course,
                    activeLessons: course.lessons,
                    activeTopic:topic ,       
                    activeLesson: lesson,
                    course_title: course.title,
                });
                resolve();
                })
            .catch((e) => {
                console.log(e);
            notify(this.props.t('Error loading the e-course'), 'error');
            this.props.user.isAuth && this.props.app.use_to_learning_class && this.props.history.push('/');
            })
            .finally(() => loader.stop("demo-course-view"))            
        })
    };

     handleSetActiveTopic = (lessons) => {
        let topic = {};
        let topics = [];
        lessons.forEach(el =>
          (!el.result || !el.result.complete) && el.topics.forEach(el =>
            (!el.result || !el.result.complete) && topics.push(el)));
        topic = topics[0];
        return topic;
      };
    
      handleNextStep = () => {
        return new Promise((resolve, reject) => {
            let course = { ...this.state.activeCourse }; 
            let topic = { ...this.state.activeTopic };
            let lesson = { ...this.state.activeLesson };
            let localActiveLessonIndex = this.state.activeLessonIndex;
            let localActiveTopicIndex = this.state.activeTopicIndex;
            

            const currentTopic = course.lessons[localActiveLessonIndex]?.topics[localActiveTopicIndex];
            const isLastTopic = localActiveTopicIndex === course.lessons[localActiveLessonIndex].topics.length - 1;            
            topic.result = { complete: true };
            course.lessons[localActiveLessonIndex].topics[localActiveTopicIndex] = topic;            
            if (!isLastTopic) {                                
                localActiveTopicIndex++;             
                resolve("EndTheme");
            } else {                
                // Завершаем урок
                lesson.result = { complete: true };
                course.lessons[localActiveLessonIndex] = lesson;
                
                const isLastLesson = localActiveLessonIndex === course.lessons.length - 1;
                console.log("is last lesson",isLastLesson);
                if (!isLastLesson) {
                    // Переходим к следующему уроку
                    localActiveLessonIndex++;
                    localActiveTopicIndex = 0;  // Сбрасываем индекс темы
                    
                    // Обновляем активные объекты
                    lesson = course.lessons[localActiveLessonIndex];
                    topic = lesson.topics[0];
                    
                    resolve("EndLesson");

                    
                }else{
                    if (course.result?.completed) {
                        resolve("DemoCourseSet");
                    } else {
                        course.result = { completed: true };
                        resolve("EndCourse");
                    }
                } 
            }

            // Обновляем state (только после всех вычислений!)
            this.setState({
                activeCourse: course,
                activeLessons: course.lessons,
                activeLesson: course.lessons[localActiveLessonIndex],
                activeTopic: course.lessons[localActiveLessonIndex]?.topics[localActiveTopicIndex],
                activeLessonIndex: localActiveLessonIndex,
                activeTopicIndex: localActiveTopicIndex
            });
        })
      };
    
      handleNextStepElCourse = (step) => {      
        this.handleNextStep()
            .then((res) => {
                let next_step = step ? step : res;
                preshiftManage.setCameFrom('demo-course-set');
                this.handleChangeContent(next_step)
            });        
      };
    
      handleExitElCourses = () => this.handleChangeContent("DemoCourseSet");

    render(){
        let Content = this.state.content;
        return  <Loader isLoading={this.props.load.isLoading} loadId={"demo-course-view"} justifyContent="center" className="Screen h-100">
                 {(Content !== DemoCourseSet && Content !== QuestionStepper)  && <Breams/>}
                                  <Content {...this.state} {...this.props}
                                            flow_uuid={this.state.activeTopic?.flow}
                                            handleChangeContent={this.handleChangeContent}
                                            handleBackCotent={()=>{this.handleChangeContent('DemoCourseSet')}}
                                            handleNextStepElCourse={this.handleNextStepElCourse}
                                            handleExitElCourses={this.handleExitElCourses}
                                            handleExitTimer={this.handleExitTimer} />
                                
        </Loader>
    }
}

const mapStateToProps = (store) => {
    return {
        app: store.appState,
        load: store.loadState,
        user: store.userState
    };
};

export default connect(mapStateToProps)(withTranslation()(DemoCourseViewContainer));